import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const CatalystsAndEnzymes = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Catalysts and Enzymes"
    videos={[
      "https://www.youtube.com/embed/Tb0nzaj7bSA",
      "https://www.youtube.com/embed/no36EgNHg6s",
      "https://www.youtube.com/embed/NGRzJWaJk7w",
    ]}
    takeaways={[
      { text: "Lock and Key method question is frequently asked." },
      { text: "Try to focus on all theory from this topics." },
    ]}
    questions={[
      "Describe why are enzyme catalysed reactions preferred in few cases despite the high cost, stability and other issues associated with enzymes.",
      "Substrate specificity is the distinctive feature of the biocatalysis. Write the significance and mechanism of this catalysis with a rate equation.",
      "Name the products and the biocatalyst used in the biocatalysis of H2O2. Apply the enzyme catalysis to the reaction and predict the mechanism."
    ]}
    exampleVideos={[]}
  />
);
}

export default CatalystsAndEnzymes;
